<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Histórico do paciente"
    >
        <BoxHistorico :data="data" />

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import BoxHistorico from './Index'

export default {
    components: {BoxHistorico},
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>